import React from "react";
import { TextField, Grid, useTheme, Typography, Modal, Backdrop } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {  RTL } from "../../../../components";
import AlertInfo from "components/AlertInfo";
import Form from "../Form";

const EditShipmentReq = (props) => {
  const { open, onClose, title, reloadFunc,onAccept,id, data, ...rest } = props;
  const theme = useTheme();

  
  return (
<>
    <Modal
        open={open}
        style={{Height:'100vh',width:'50%',marginRight:'25%',marginLeft:'25%', display: 'flex',
        justifyContent: 'center',
        alignItems: 'center', }}      
        
        onClose={onClose}
      >
        <div style={{backgroundColor:'white',padding:'2%',  border: "none",width:'100%'
}}>
        <Form reloadFunc={reloadFunc} onClose={onClose} data={data || undefined} id={id} edit={true}/>

        </div>
      </Modal>
 

      {/* <AlertInfo
        fullWidth={true}
        onClose={onClose}
        onAccept={onAccept}
        {...rest}
        maxWidth={"sm"}
        title={props.title}
        open={open}
      >
       <Form edit={true}/>
      </AlertInfo> */}
  </>
  );
};

export default EditShipmentReq;
